import { useAutoAnimate } from "@formkit/auto-animate/react";
import { AlertProvider } from "@gymflow/common";
import {
  matchPath,
  Redirect,
  Route,
  Switch,
  useRouteMatch,
} from "react-router-dom";

import { HostedPagesNavbar } from "../components/organisms";
import { HostedPagesFooter } from "../components/site/components/HostedPagesFooter";
import { useHtmlNodeDarkMode, useInjectWebsiteCustomizations } from "../hooks";
import {
  ClubSettingsProvider,
  ModalProvider,
  useClubSettings,
} from "../providers";
import { AuthenticationProvider } from "../providers/authentication/AuthenticationProvider";
import { SessionOverlayProvider } from "../providers/authentication/SessionOverlay/SessionOverlayProvider";
import { OnboardingProvider } from "../providers/OnboardingProvider/OnboardingProvider";
import {
  generateSiteWithAuthRoutes,
  RouteDefinition,
  RouteFeatureSite,
} from "../routes";

export function Site() {
  return (
    <AuthenticationProvider userType="member">
      <ClubSettingsProvider enableColorCustomization>
        <ModalProvider>
          <AlertProvider>
            <OnboardingProvider>
              <SiteWithAuth />
            </OnboardingProvider>
          </AlertProvider>
        </ModalProvider>
      </ClubSettingsProvider>
    </AuthenticationProvider>
  );
}

function SiteWithAuth() {
  const match = useRouteMatch();

  const getRoutes = (routes: RouteDefinition[]) => {
    const nodes = routes.map((prop) => {
      return (
        <Route path={match.path + prop.path} key={prop.path}>
          {(props) => <prop.component {...props} />}
        </Route>
      );
    });
    return nodes;
  };


  const propertiesSettings = useClubSettings();
  const routesWithAuth = generateSiteWithAuthRoutes(propertiesSettings);

  useHtmlNodeDarkMode({ supportDarkMode: true });
  useInjectWebsiteCustomizations();

  const isStripeEnabled = propertiesSettings.club.stripeAccountType === "STANDARD" || "CONNECTED";
  const isNotAvailableRoute = matchPath(
    match.url + RouteFeatureSite.NotAvailable,
    window.location.pathname,
  );
  const [parent] = useAutoAnimate();
  if (!isStripeEnabled && !isNotAvailableRoute) {
    return <Redirect to={match.url + RouteFeatureSite.NotAvailable} />;
  }
  return (
    <SessionOverlayProvider>
      <div className="bg-gray-0 flex size-full flex-col justify-between overflow-hidden dark:bg-gray-800">
        <HostedPagesNavbar />
        <div ref={parent} className="flex-1 overflow-y-auto">
          <Switch>{getRoutes(routesWithAuth)}</Switch>
        </div>
        <HostedPagesFooter />
      </div>
    </SessionOverlayProvider>
  );
}
